var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    overflow: "hidden",
    preserveAspectRatio: "xMidYMid meet",
    id: "eaf-10da0-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eaf-10da0-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url('#eaf-10da0-1')",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.2236 1.0002l17.0903 0c1.9123 0 3.4625 1.4489 3.4625 3.573l0 13.1556c0 1.822 -2.5565 2.7058 -3.9892 1.379l-4.7015 -3.584l-4.7014 3.584c-1.4327 1.3268 -3.9892 0.4433 -3.9892 -1.3787l0 -10.1549c0 -6.7183 -3.1715 -6.574 -3.1715 -6.574z",
    transform: "translate(0.5 -0.4854)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.0018e77df377d2b47c51af99e6cda348.svg";
export { ForwardRef as ReactComponent };